
// export const myGetter = ( state ) => {
//   return
// }
export const getPeriod = ( state ) => {
    return state.period
}

export const getCurrentPeriod = ( state ) => {
    return state.currentPeriod
}

export const getWeeks = ( state ) => {
    return state.weeks
}

export const getSpecialWeeks = ( state ) => {
    return state.specialWeeks
}